/* eslint-disable @typescript-eslint/no-explicit-any */
import avatarImg from '../../../img/avatar.png'

export const dataSource: any[] = [
    {
        key: '1',
        UserInfo: {
            name: 'Brad Nichols',
            avatar: avatarImg,
            email: 'bradleygrantnichols@gmial,com',
        },
        Role: 'Admin',
        Registered: {
            date: 'March 18, 2020',
            day: 'Sunday',
        },
        Projects: '6',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '2',
        UserInfo: {
            name: 'Brandon Zuniga',
            avatar: avatarImg,
            email: 'Bzuniga@gmail.com',
        },
        Role: 'Admin',
        Registered: {
            date: 'February 14, 2020',
            day: 'Friday',
        },
        Projects: '5',
        Revenue: '$0.00',
        Status: 'Revoked',
        Action: {
            more: true,
        },
    },
    {
        key: '3',
        UserInfo: {
            name: 'Fred Oberbrunner',
            avatar: avatarImg,
            email: 'Oberbrunner@gmail.com',
        },
        Role: 'Free',
        Registered: {
            date: 'May 20, 2002',
            day: 'Tuesday',
        },
        Projects: '6',
        Revenue: '$0.00',
        Status: 'Revoked',
        Action: {
            more: true,
        },
    },
    {
        key: '4',
        UserInfo: {
            name: 'Harrison P',
            avatar: avatarImg,
            email: 'harry@address.com',
        },
        Role: 'Free',
        Registered: {
            date: 'April 32, 2056',
            day: 'Monday',
        },
        Projects: '4',
        Revenue: '$0.00',
        Status: 'Revoked',
        Action: {
            more: true,
        },
    },
    {
        key: '5',
        UserInfo: {
            name: 'Andrej Ostopenka',
            avatar: avatarImg,
            email: 'a_ostap@sexproduct.com',
        },
        Role: 'Assist',
        Registered: {
            date: 'December 4, 2020',
            day: 'Sunday',
        },
        Projects: '3',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '6',
        UserInfo: {
            name: 'Huan Pidrilio Gonzales',
            avatar: avatarImg,
            email: 'huanito@balls.com',
        },
        Role: 'Solo',
        Registered: {
            date: 'May 26, 2002',
            day: 'Monday',
        },
        Projects: '2',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '7',
        UserInfo: {
            name: 'Roman Kwakushken',
            avatar: avatarImg,
            email: 'roman@success.com',
        },
        Role: 'Free',
        Registered: {
            date: 'May 16, 2002',
            day: 'Friday',
        },
        Projects: '1',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '8',
        UserInfo: {
            name: 'Rose Satter',
            avatar: avatarImg,
            email: 'shatter@address.com',
        },
        Role: 'Free',
        Registered: {
            date: 'October 11, 2017',
            day: 'Tuesday',
        },
        Projects: '2',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '9',
        UserInfo: {
            name: 'Tred Fred',
            avatar: avatarImg,
            email: 'tredfred@yahoo.com',
        },
        Role: 'Free',
        Registered: {
            date: 'May 6, 2020',
            day: 'Sunday',
        },
        Projects: '2',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '10',
        UserInfo: {
            name: 'Ciara Konopelli',
            avatar: avatarImg,
            email: 'bingbong@dja.com',
        },
        Role: 'Free',
        Registered: {
            date: 'January 32, 2018',
            day: 'Friday',
        },
        Projects: '1',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '11',
        UserInfo: {
            name: 'Harrison P.',
            avatar: avatarImg,
            email: 'harry@address.com',
        },
        Role: 'Free',
        Registered: {
            date: 'April 32, 2056',
            day: 'Monday',
        },
        Projects: '1',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
    {
        key: '12',
        UserInfo: {
            name: 'Dred oberbunner',
            avatar: avatarImg,
            email: 'Ober brunner@mail.com',
        },
        Role: 'Solo',
        Registered: {
            date: 'May 20, 2002',
            day: 'Tuesday',
        },
        Projects: '1',
        Revenue: '$0.00',
        Status: 'Active',
        Action: {
            more: true,
        },
    },
]
